<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    :tabs="getTabs"
    :selectedIndex="getTabIndex"
    ref="gc-base-layout"
    class="bank-reconciliation"
  >
    <slot> </slot>
    <template #headerContent>
      <GcHeaderContentDynamic
        :title="'Bank Reconciliation'"
        :createModeIsEditMode="true"
        :baseView="baseView"
        :primaryLabel="dataModel.AccountName"
        :secondaryLabel="dataModel.BsbNo + ' ' + dataModel.AccountNo"
        v-if="loaded"
      />
    </template>

    <div class="css-v2 transaction-screen" v-if="loaded">
      <div class="gc-header-toolbar">
        <gc-form-header-toolbar
          :toolbar-options="getHeaderToolbar"
          :data-model="loaded ? dataModel : {}"
          :itemSaveCallBack="checkHeaderFormValidation"
          :backRoute="backButtonRoute"
          :setLoading="showLoading"
          ref="gc-form-header-toolbar"
          :baseView="baseView"
        ></gc-form-header-toolbar>
      </div>

      <div class="gc-header-form" v-show="!gridExpand">
        <div class="header-form">
          <div class="view-card responsive-paddings">
            <gc-form
              :formOptions="{
                gcLabelLocation: 'left',
              }"
              :formItems="getHeaderFormItems"
              :isNormal="true"
              :data-model="loaded ? dataModel : {}"
              :formMode="baseView.mode"
              :fromFrom="'gc-header-form'"
              ref="gc-header-form"
              :checkValid="isValid"
              :validationGroup="'gc-header-form'"
              :scrollingEnabled="false"
              :formHeight="125"
              :formContentReady="onHeaderFormContentReady"
            ></gc-form>
          </div>
        </div>
      </div>

      <div class="gc-details-grid" v-if="loaded">
        <gc-filter-split-view
          :showLeftContainer="showLeftContainer"
          :showRightContainer="showRightContainer"
          :rightContainerWidth="250"
        >
          <template #leftContent>
            <DxTreeList
              :data-source="getDataSource"
              :show-row-lines="true"
              :show-borders="true"
              :show-column-lines="true"
              :column-auto-width="true"
              :height="getGridHeight"
              items-expr="Items"
              data-structure="tree"
              :word-wrap-enabled="true"
              @selection-changed="onSelectionChanged"
              @toolbar-preparing="onToolbarPreparing"
              @content-ready="onContentReady"
              :column-chooser="{
                enabled: true,
                allowSearch: true,
                mode: 'select',
                height: '100%',
                width: 300,
              }"
              ref="bank-reconciliation-tree"
              :no-data-text="'No outstanding items to reconcile.'"
            >
              <DxSearchPanel :visible="false" />
              <DxSelection :recursive="true" mode="multiple" />
              <DxColumn
                data-field="Key"
                caption=""
                :fixed="true"
                :showInColumnChooser="false"
                :width="230"
              />
              <!-- <DxColumn data-field="TransactionDate" :format="'dd MMM yyyy'"/>
              <DxColumn data-field="TransactionMethod" />
              <DxColumn data-field="TransactionType" /> -->
              <!-- :min-width="getColumnWidth('TransactionPartner')"
              :width="getColumnWidth('TransactionPartner')" -->

              <DxColumn
                data-field="TransactionPartner"
                caption="Partner"
                :wordWrapEnabled="true"
                :min-width="getColumnWidth('TransactionPartner')"
              />
              <DxColumn
                data-field="ComputedTransactionNo"
                caption="Transaction"
                cell-template="Hyperlink"
                :width="getColumnWidth('TransactionNo')"
                :minWidth="getColumnMinWidth('TransactionNo')"
              />

              <template #Hyperlink="{ data }">
                <div>
                  <a @click="onHyperlinkClicked(data)">
                    <span>{{ data.text }}</span>
                  </a>
                </div>
              </template>
              <DxColumn
                data-field="Reference"
                :width="getColumnWidth('Username')"
                :minWidth="getColumnMinWidth('Username')"
              />
              <DxColumn
                data-field="DateCreated"
                data-type="date"
                :format="'dd MMM yyyy'"
                :width="getColumnWidth('DateCreated')"
              />
              <DxColumn
                data-field="TransactionDate"
                data-type="date"
                :format="'dd MMM yyyy'"
                :visible="false"
                :show-in-column-chooser="false"
              />
              <DxColumn
                data-field="CreatedBy"
                :width="getColumnWidth('Username')"
                :minWidth="getColumnMinWidth('Username')"
              />
              <DxColumn
                data-field="ExchangeRate"
                format="#0.0000"
                :visible="IsForeignCurrencyAccount"
                :width="getColumnWidth('ExchangeRate')"
                :minWidth="getColumnMinWidth('ExchangeRate')"
              />
              <DxColumn
                data-field="FXTransactionAmount"
                :caption="`FX Amount (${dataModel.CurrencyCode})`"
                cell-template="Decimal"
                format="###,###.00"
                :visible="IsForeignCurrencyAccount"
                :width="getColumnWidth('Amount')"
                :minWidth="getColumnMinWidth('Amount')"
              />
              <DxColumn
                data-field="TransactionAmount"
                :caption="`Amount (${BaseCurrency})`"
                cell-template="Decimal"
                format="###,###.00"
                :width="getColumnWidth('Amount')"
                :minWidth="getColumnMinWidth('Amount')"
              />
              <template #Decimal="{ data }">
                <GcDecimal :dataValue="data" :format="'###,###.00'" />
              </template>
            </DxTreeList>
          </template>
          <template #rightContent>
            <div
              class="advance-filter-panel"
              :key="'fpanel-bank-reconciliation-tree'"
            >
              <DxToolbar class="split-view-toolbar">
                <dx-item
                  location="before"
                  widget="dxTabs"
                  :options="filterPanelTabOptions"
                  selected-index="0"
                ></dx-item>

                <DxItem
                  :options="filterToolbar.clear"
                  location="after"
                  locate-in-menu="auto"
                  widget="dxButton"
                  :visible="false"
                />

                <DxItem
                  :options="filterToolbar.close"
                  location="after"
                  widget="dxButton"
                />
              </DxToolbar>
              <gc-filter-panel
                :toolbarVisible="false"
                :formItemData="filterFormItems"
                :setGridPanelFilter="setGridPanelFilter"
                :gridFoolter="false"
                :showLoading="showLoading"
                :from="'stand-alone'"
                :isNormal="false"
                :key="'fp-bank-reconciliation-tree'"
                :overWriteClear="true"
              >
              </gc-filter-panel>
            </div>
          </template>
        </gc-filter-split-view>
      </div>
    </div>

    <GcSundryTransactionPopup
      v-if="gcSundryTransactionPopupConfig.gcPopupVisible"
      :visible="gcSundryTransactionPopupConfig.gcPopupVisible"
      :gcSundryTransactionPopupConfig="gcSundryTransactionPopupConfig"
      :setLoading="showLoading"
      :showValidationSummary="displayValidationSummary"
    />
  </GcBaseLayout>
</template>
<script>
// Red - Not-Reconsiled
// no outstanding items to reconsile
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import DataGridMixin from "@/_mixins/data-grid.mixin";
import {
  BankAccountTransferTabs,
  GetIndexByTabName,
} from "../../../_models/tabdata/finance/bank-account-transaction";
import { BankAccountsServices } from "../../../_services/api/finance/bankAccounts";

import {
  DxTreeList,
  DxSelection,
  DxColumn,
  DxSearchPanel,
} from "devextreme-vue/tree-list";
import DataSource from "devextreme/data/data_source";
import ArrayStore from "devextreme/data/array_store";
import { mapGetters } from "vuex";
import { getDefaultUserSettings } from "../../../_store/helpers";
import { BankAccountTransactionServices } from "../../../_services/api/finance/bank-account-transaction.service";
import ColumnWidth from "../../../_helpers/data-grid/ColumnWidth";
import validationEngine from "devextreme/ui/validation_engine";

export default {
  mixins: [RouteMixin, FormMixin, DataGridMixin],
  components: {
    DxTreeList,
    DxSelection,
    DxColumn,
    DxSearchPanel,
  },
  data() {
    return {
      dataModel: {
        AccountName: undefined,
        AccountNo: undefined,
        BsbNo: undefined,
        SaveAs: "C",
        FriendlyStatus: "Not Reconciled",
      },
      loaded: false,
      gridExpand: false,
      isValid: false,
      showLeftContainer: true,
      showRightContainer: true,
      reconciliationDetailRecords: [],
      headerFormHeight: 0,
      reconciledRecordObjs: [],
      BankBookReconciliationStatementDate: undefined,
      BankBookReconciliationFXStatementBalance: undefined,
      BaseCurrency: "AUD",

      filterToolbar: {
        close: {
          icon: "showpanel",
          onClick: () => {
            this.closeFilterPanel();
          },
          // visible: browserHelper.tablet,
        },
        clear: {
          text: "Clear",
          onClick: () => {
            this.clearAdvanceFilters();
          },
        },
      },
      gcSundryTransactionPopupVisible: false,
      selectedGridItems: [],
      selectedRowIds: [],
      IsAllExpand: false,
    };
  },
  async created() {
    this.showLoading(true);
    await this.initialized();

    this.loaded = true;
    this.showLoading(false);
  },
  methods: {
    getColumnWidth(Column) {
      return ColumnWidth.getValue(Column).width;
    },
    getColumnMinWidth(Column) {
      return ColumnWidth.getValue(Column).minWidth;
    },
    onContentReady(e) {
      if (this.reconciledRecordObjs.length > 0) {
        let dataTree = e.component.instance();
        let rowKeys = [];

        dataTree.pageSize(dataTree.getDataSource()._totalCount);

        dataTree
          .getDataSource()
          .load()
          .then((allRows) => {
            let getItems = (data) => {
              data.forEach((element) => {
                if (element.hasChildren) {
                  getItems(element.children);
                } else {
                  if (element.data.IsDraft === "YES") {
                    rowKeys.push(element.data.id);
                  }
                }
              });
            };

            getItems(allRows);
            if (rowKeys.length > 0) dataTree.selectRows(rowKeys, true);
            this.reconciledRecordObjs = [];
          });
      }
    },
    onToolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;

      var columnChooserButton = toolbarItems.find((item) => {
        return item.name === "columnChooserButton";
      });

      e.toolbarOptions.items = toolbarItems.filter((item) => {
        return item.name !== "columnChooserButton";
      });

      e.toolbarOptions.items.push({
        location: "before",
        widget: "dxButton",
        options: {
          icon: "plus",
          text: "Add New",
          onClick: () => {
            this.visibleGcSundryTransactionPopup();
          },
        },
      });

      e.toolbarOptions.items.push({
        location: "after",
        widget: "dxButton",
        options: {
          icon: this.IsAllExpand ? "chevronup" : "chevrondown",
          text: this.IsAllExpand ? "Collapse" : "Expand",
          onClick: () => {
            this.expandOrCollapse();
          },
        },
      });
      e.toolbarOptions.items.push(columnChooserButton);

      e.toolbarOptions.items.push({
        location: "after",
        locateinmenu: "auto",
        widget: "dxButton",
        options: {
          validationGroup: "formsData",
          icon: "filter",
          elementAttr: { id: "filter-btn" },
          onClick: () => {
            this.showRightContainer = !this.showRightContainer;
            var item = document.getElementById("filter-btn");
            this.$logger.debug("item ", item);
            item.classList.add("dx-state-invisible");

            setTimeout(() => {
              this.reSizeTreeList();
            }, 50);
          },
          visible: !this.showRightContainer,
        },
      });
    },
    expandOrCollapse() {
      var treeList = this.$refs["bank-reconciliation-tree"].instance;
      treeList.beginUpdate();
      treeList.forEachNode((node) => {
        if (!this.IsAllExpand) treeList.expandRow(node.key);
        else treeList.collapseRow(node.key);
      });
      treeList.endUpdate();
      this.IsAllExpand = !this.IsAllExpand;
      setTimeout(() => {
        treeList.repaint();
      }, 50);
    },
    reSizeTreeList() {
      var treeList = this.$refs["bank-reconciliation-tree"].instance;

      treeList.beginUpdate();
      treeList.updateDimensions();
      treeList.endUpdate();
    },
    onSelectionChanged(e) {
      let instance = e.component.instance();

      e.currentSelectedRowKeys.forEach((element) => {
        this.onRowSelect(instance.getNodeByKey(element));
      });

      e.currentDeselectedRowKeys.forEach((element) => {
        this.onRowDeSelect(instance.getNodeByKey(element));
      });

      this.selectedGridItems = instance.getSelectedRowsData("leavesOnly");
    },
    onRowSelect(node) {
      if (node.hasChildren) {
        node.children.forEach((element) => {
          this.onRowSelect(element);
        });
      } else {
        let data = { ...node.data };
        var index = this.selectedRowIds.findIndex((x) => x == data.id);
        if (index == -1) {
          this.selectedRowIds.push(data.id);
          if (
            data.TransactionType == "Sundry Payment" ||
            data.TransactionType == "Supplier Payment" ||
            data.TransactionType == "Cash Payment"
          ) {
            this.dataModel.FXOutstandingPaymentTotal +=
              data.FXTransactionAmount;
            this.dataModel.FXReconciledPayments += -data.FXTransactionAmount;
          } else {
            this.dataModel.FXOutstandingReceiptTotal +=
              -data.FXTransactionAmount;
            this.dataModel.FXReconciledReceipts += data.FXTransactionAmount;
          }
        }
        this.calHeaderValues();
      }
    },
    onRowDeSelect(node) {
      if (node.hasChildren) {
        node.children.forEach((element) => {
          this.onRowDeSelect(element);
        });
      } else {
        let data = { ...node.data };
        var index = this.selectedRowIds.findIndex((x) => x == data.id);
        if (index != -1) this.selectedRowIds.splice(index, 1);
        if (
          data.TransactionType == "Sundry Payment" ||
          data.TransactionType == "Supplier Payment" ||
          data.TransactionType == "Cash Payment"
        ) {
          this.dataModel.FXOutstandingPaymentTotal -= data.FXTransactionAmount;
          this.dataModel.FXReconciledPayments -= -data.FXTransactionAmount;
        } else {
          this.dataModel.FXOutstandingReceiptTotal -= -data.FXTransactionAmount;
          this.dataModel.FXReconciledReceipts -= data.FXTransactionAmount;
        }
        this.calHeaderValues();
      }
    },
    async calHeaderValues() {
      this.dataModel.FXAccountBalance = (
        this.dataModel.FXBookBalance +
        this.dataModel.FXOutstandingPaymentTotal - // / OutstandingReceiptTotal is a negative value
        this.dataModel.FXOutstandingReceiptTotal
      ).roundNumber(2);
      this.dataModel.FXVarience = (
        this.dataModel.FXAccountBalance - this.dataModel.FXStatementBalance
      ).roundNumber(2);

      var headerFormInstance =
        this.$refs["gc-header-form"].$refs["gc-form-comp"].instance;
      headerFormInstance.updateData(this.dataModel);
    },

    async initialized() {
      if (getDefaultUserSettings().CurrencyCode)
        this.BaseCurrency = getDefaultUserSettings().CurrencyCode;
      else this.BaseCurrency = "AUD";

      await BankAccountsServices.getGroupedReconciliationDetail(
        this.baseView.id
      )
        .then((res) => {
          res.data.forEach((element) => {
            element.Key = new Date(element.Key).toShortDateString();
          });

          let allItems = this.getLastLevelItems(res.data);
          allItems.forEach((element) => {
            element.IsDraft === "YES"
              ? this.reconciledRecordObjs.push(element)
              : (element.IsDraft = "NO");

            // if (element.IsDraft === "YES") {
            //   this.BankBookReconciliationFXStatementBalance = element.BankBookReconciliationFXStatementBalance;
            //   this.BankBookReconciliationStatementDate = element.BankBookReconciliationStatementDate;
            // }
          });

          this.reconciliationDetailRecords = res.data;
        })

        .catch((err) => {
          if (err) this.setLoading = false;
        });
      await BankAccountsServices.getBankRecordByCode(this.baseView.id).then(
        (res) => {
          this.dataModel = res.data.value[0];
          this.dataModel.BankAccountCode = this.dataModel.Code;
          this.dataModel.FXStatementBalance = this.dataModel.StatementBalance;

          // if (this.dataModel.FriendlyStatus == "Uncommitted Reconciliation") {
          //   this.dataModel.FXStatementBalance = this.BankBookReconciliationFXStatementBalance;
          //   this.dataModel.StatementDate = this.BankBookReconciliationStatementDate;
          // }
          // else {
          //   this.dataModel.FriendlyStatus = "Not Reconciled";
          // }

          this.dataModel.FXAccountBalance = (
            this.dataModel.FXBookBalance +
            this.dataModel.FXOutstandingPaymentTotal -
            this.dataModel.FXOutstandingReceiptTotal
          ).roundNumber(2);

          this.dataModel.FXVarience = (
            this.dataModel.FXAccountBalance - this.dataModel.FXStatementBalance
          ).roundNumber(2);

          this.dataModel.FXReconciledPayments = 0;
          this.dataModel.FXReconciledReceipts = 0;
        }
      );
    },
    getLastLevelItems(array) {
      let lastLevelItems = [];

      function traverse(array) {
        array.forEach((item) => {
          if (item.Key) {
            traverse(item.Items);
          } else {
            lastLevelItems.push(item);
          }
        });
      }

      traverse(array);
      return lastLevelItems;
    },
    saveBankReconciliation() {
      // console.log("saveBankReconciliation");
    },
    async checkHeaderFormValidation() {
      let data = this.dataModel;

      let validationResult = await validationEngine.validateGroup(
        "gc-form-header-toolbar"
      );

      if (!validationResult.isValid) {
        var index = validationResult.brokenRules.findIndex(
          (x) => x.message == "Value is out of range"
        );
        if (index != -1) {
          validationResult.brokenRules[
            index
          ].message = `Please enter a Statement Date that is between ${new Date(
            this.dataModel.LastReconciledDate
          ).toShortDateString()} and ${new Date().toShortDateString()}.`;
        }
        this.displayValidationSummary(validationResult.brokenRules);
      } else {
        if (this.selectedGridItems.length === 0) {
          this.$alert(
            "Please include one or more entries before attempting to save",
            "Error"
          );
          return;
        }

        if (this.dataModel.SaveAs == "C") {
          if (data.FXVarience !== 0) {
            this.$alert(
              "The Statement Balance you are attempting to commit does not match the calculated Account Balance. Please review the reconciled items and ensure that there is no variance before proceeding to commit this reconciliation",
              "Error"
            );
            return;
          }
        }

        const isConfirm = await this.$confirm(
          this.dataModel.SaveAs != "C"
            ? "You are about to save this Bank Reconciliation without committing. You will be able to retrieve this reconciliation and make further changes. Do you wish to proceed?"
            : "You are about to commit this Bank Reconciliation and you will not be able to make further changes. Do you wish to proceed?",
          "Confirmation"
        );
        if (isConfirm) {
          this.showLoading(true);
          var FXCalculatedCashbookReceipts = 0;
          var FXCalculatedCashbookPayments = 0;
          this.selectedGridItems.forEach((gridItem) => {
            if (gridItem.IsDraft == "Yes") {
              FXCalculatedCashbookReceipts += gridItem.FXTransactionAmount;
              FXCalculatedCashbookPayments += gridItem.FXTransactionAmount;
            }
          });

          const payload = {
            BankBookHeader: {
              BankAccountCode: data.BankAccountCode,
              BankStatementDate: new Date(data.StatementDate).toSaveDate(),
              FXBankStatementBalance: data.FXStatementBalance,
              LastReconciledDate: data.LastReconciledDate,
              LastReconciledAmount: data.LastReconciledAmount,
              TotalPayments: data.PaymentTotal,
              TotalReceipts: data.ReceiptTotal,
              FXBankBookBalance: data.FXBookBalance,
              FXOpeningBankBookBalance: data.FXOpeningBalance,
              FXTotalOutstandingPayments: data.FXOutstandingPaymentTotal,
              FXTotalOutstandingReceipts: Math.abs(
                data.FXOutstandingReceiptTotal
              ),
              BankName: data.CompanyBank,
              BankBranch: data.BankBranch,
              BSBNo: data.BsbNo,
              BankAccountName: data.AccountName,
              BankAccountNo: data.AccountNo,
              GcorpBankFileExportCode: data.ExportCode,
              GLControlAccount: data.ControlAccount,
              ABABankId: data.UserBank,
              ABAUserCode: data.AbaUserCode,
              OpeningBalanceFiscalPeriod: data.OpenningBalanceFiscalPeriod,
              OpeningBalanceFiscalYear: data.OpenningBalanceFiscalYear,
              FXCalculatedCashbookReceipts: FXCalculatedCashbookReceipts,
              FXCalculatedCashbookPayments: FXCalculatedCashbookPayments,
              FXAccountBalance: data.FXAccountBalance,
              Difference: data.FXVarience,
              CommitReconciliation: this.dataModel.SaveAs == "C",
            },
            BankBookTransactionCollection: [],
          };
          this.selectedGridItems.forEach((gridItem) => {
            const BankBookTransaction = {
              AccountPeriod: gridItem.AccountPeriod,
              BankAccountCode: data.BankAccountCode,
              CashBookNo: gridItem.RefNo,
              Inactive: gridItem.Inactive,
              // IsCommitted: gridItem.IsCommitted,
              IsCommitted: true,
              Status: gridItem.Status,
              TotalRowCount: 0,
              FXTransactionAmount: gridItem.FXTransactionAmount,
              TransactionChequeNo: gridItem.TransactionChequeNo,
              TransactionComment: gridItem.TransactionPartner,
              TransactionDate: gridItem.TransactionDate,
              TransactionMethod: gridItem.TransactionMethod,
              TransactionNo: gridItem.TransactionNo,
              TransactionType: gridItem.TransactionType,
            };
            payload.BankBookTransactionCollection.push(BankBookTransaction);
          });

          await BankAccountTransactionServices.saveBankReconciliation(payload)
            .then((res) => {
              this.showLoading(false);
              if (res) {
                this.$notify(`Bank Reconciliation Successful`, "success");
                this.setIgnoreRouteChangeConfirmation();
                if (this.baseView.query.from === "bank-account-list") {
                  this.$router.push({
                    path: `/bank-accounts`,
                  });
                } else {
                  this.$router.push({
                    path: `/bank-accounts-transaction/review/${this.baseView.id}`,
                  });
                }
              }
            })
            .catch((err) => {
              this.showLoading(false);

              this.displayServerError(err, "Save Failed");
            });
        }
      }
    },
    backButtonFunction() {
      this.$router
        .push({
          path: this.backButtonRoute,
        })
        .then(() => {
          this.$store.dispatch("dataContext/setDataViewType", undefined);
        });
    },
    calculateFXVarience(value) {
      this.dataModel.FXVarience = (
        this.dataModel.FXAccountBalance - value
      ).roundNumber(2);

      var headerFormInstance =
        this.$refs["gc-header-form"].$refs["gc-form-comp"].instance;
      headerFormInstance.updateData(this.dataModel);
    },
    onHyperlinkClicked(e) {
      let baseUrl = process.env.VUE_APP_BASE_URL;
      let url = undefined;
      if (e.data.TransactionType == "Customer Receipt") {
        url = `customer-receipt/review/${e.data.TransactionNo}`;
      } else if (e.data.TransactionType == "Sundry Receipt") {
        url = `sundry-receipt/${e.data.TransactionNo}`;
      } else if (e.data.TransactionType == "Supplier Payment") {
        url = `supplier-payment/review/${e.data.TransactionNo}`;
      } else if (e.data.TransactionType == "Sundry Payment") {
        url = `sundry-payment/${e.data.TransactionNo}`;
      }

      if (url) {
        if (baseUrl != "/") url = "/" + url;
        else url = baseUrl + url;
        var route = this.$router.resolve({ path: url });
        window.open(route.href, "_blank");
      }
    },
    onHeaderFormContentReady() {
      const headerForm = document.querySelectorAll(".gc-header-form");
      this.headerFormHeight = headerForm[0].clientHeight;

      // if (
      //   e &&
      //   this.baseView.mode == "edit" &&
      //   this.IsCustomerEditable == false
      // ) {
      //   setTimeout(() => {
      //     var headerToolBarForm = e.component;
      //     if (headerToolBarForm && headerToolBarForm.getEditor("DateIn"))
      //       headerToolBarForm.getEditor("DateIn").instance().focus();
      //   }, 500);
      // }
    },

    // Sundry
    visibleGcSundryTransactionPopup() {
      this.gcSundryTransactionPopupVisible = true;
    },
    gcSundryTransactionPopupCallBack() {
      this.gcSundryTransactionPopupVisible = false;
    },

    // Filter Panel
    closeFilterPanel() {
      this.showRightContainer = !this.showRightContainer;

      var item = document.getElementById("filter-btn");
      item.classList.remove("dx-state-invisible");

      setTimeout(() => {
        this.reSizeTreeList();
      }, 50);
    },

    setGridPanelFilter(filters, valueChanged) {
      let dataTreeList = this.$refs["bank-reconciliation-tree"].instance;

      if (valueChanged != undefined || filters.length > 0) {
        if (filters.length > 0) dataTreeList.filter(filters);
        else if (filters.length == 0) dataTreeList.clearFilter();

        dataTreeList.refresh(true);
      }
      this.showLoading(false);
    },
  },
  computed: {
    ...mapGetters({ gridHeight: "ui/getHeightForDataGrid" }),
    IsForeignCurrencyAccount() {
      return this.dataModel.CurrencyCode !== this.BaseCurrency;
    },
    getGridHeight() {
      return this.gridHeight - 75 - this.headerFormHeight;
    },
    getDataSource() {
      return new DataSource({
        store: new ArrayStore({
          // key: "ID",
          data: this.reconciliationDetailRecords,
        }),
        reshapeOnPush: true,
      });
    },
    getHeaderFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 2,
          items: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  screenField: "FXBookBalance",
                  dataField: "FXBookBalance",
                  label: {
                    text: `GCORP Balance (${this.dataModel.CurrencyCode})`,
                  },
                  value: this.dataModel.FXBookBalance,
                  format: "Decimal-8-2",
                  allowUpdate: false,
                  editorOptions: {
                    tabIndex: -1,
                  },
                },

                {
                  screenField: "Total",
                  dataField: "FXOutstandingPaymentTotal",
                  label: {
                    text: `Add O/S Payments (${this.dataModel.CurrencyCode})`,
                  },
                  value: this.dataModel.FXOutstandingPaymentTotal,
                  allowUpdate: false,
                  format: "Decimal-8-2",
                  editorOptions: {
                    tabIndex: -1,
                  },
                },
                {
                  screenField: "Total",
                  dataField: "FXOutstandingReceiptTotal",
                  label: {
                    text: `Less O/S Receipts (${this.dataModel.CurrencyCode})`,
                  },
                  allowUpdate: false,
                  format: "Decimal-8-2",
                  editorOptions: {
                    tabIndex: -1,
                  },
                },
                {
                  screenField: "Total",
                  dataField: "FXAccountBalance",
                  label: {
                    text: `Account Balance (${this.dataModel.CurrencyCode})`,
                  },
                  allowUpdate: false,
                  format: "Decimal-8-2",
                  editorOptions: {
                    tabIndex: -1,
                  },
                },
              ],
            },

            {
              itemType: "group",
              caption: "",
              items: [
                {
                  screenField: "Balance",
                  dataField: "FXStatementBalance",
                  label: {
                    text: `Statement Balance (${this.dataModel.CurrencyCode})`,
                  },
                  format: "Decimal-8-2",
                  allowUpdate: true,
                  editorOptions: {
                    onValueChanged: ({ value }) => {
                      this.calculateFXVarience(value);
                    },
                    min: -99999999.0,
                    max: 99999999.0,
                  },
                  validationRules: [
                    {
                      type: "range",
                      message:
                        "Statement Balance is not between 99999999.0 and 99999999.0",
                      min: -99999999.0,
                      max: 99999999.0,
                    },
                  ],
                },
                {
                  screenField: "Total",
                  dataField: "FXReconciledPayments",
                  label: {
                    text: `R/C Payments (${this.dataModel.CurrencyCode})`,
                  },
                  allowUpdate: false,
                  editorOptions: {
                    tabIndex: -1,
                  },
                },
                {
                  screenField: "Total",
                  dataField: "FXReconciledReceipts",
                  label: {
                    text: `R/C Receipts (${this.dataModel.CurrencyCode})`,
                  },
                  allowUpdate: false,
                  editorOptions: {
                    tabIndex: -1,
                  },
                },
                {
                  screenField: "Total",
                  dataField: "FXVarience",
                  label: {
                    text: `Variance (${this.dataModel.CurrencyCode})`,
                  },
                  cssClass:
                    this.dataModel.FXVarience === 0
                      ? "bold-text"
                      : "red-bold-text",
                  allowUpdate: false,
                  editorOptions: {
                    tabIndex: -1,
                  },
                },
              ],
            },
          ],
        },
      ];
    },
    getHeaderToolbar() {
      return {
        screenName: "Bank Reconciliation ",
        pdf: false,
        audit: false,
        status: true,
        notes: false,
        edit: false,
        save: true,
        saveOptions: {
          items: [
            { text: "Save & Commit", id: "C", default: true },
            { text: "Save as Draft", id: "D" },
          ],

          keyExpr: "id",
          displayExpr: "text",
          dropDownOptions: {
            width: "150px",
          },
          saveKey: "SaveAs",
        },
        headerFormVisible: true,
        toolbarFormItems: [
          {
            screenField: "DateIn",
            dataField: "StatementDate",
            label: {
              text: "Statement Date",
            },
            editorOptions: {
              max: new Date(),
              min: this.dataModel.LastReconciledDate,
              width: 120,
            },
            allowUpdate: true,
            required: true,
          },
        ],
        saveCallback: this.saveBankReconciliation,
      };
    },
    backButtonRoute() {
      if (this.baseView.query.from === "bank-account-list") {
        return "/bank-accounts";
      }
      return `/bank-accounts-transaction/review/${this.baseView.id}`;
    },
    getTabs() {
      return BankAccountTransferTabs(this.baseView.id);
    },
    getTabIndex() {
      return GetIndexByTabName("Reconcile", this.baseView.id);
    },

    // Sundry
    gcSundryTransactionPopupConfig() {
      return {
        gcPopupVisible: this.gcSundryTransactionPopupVisible,
        gcPopupCallBack: this.gcSundryTransactionPopupCallBack,
        init: async () => {
          this.showLoading(true);
          await this.initialized();
          this.showLoading(false);
        },
        onSaveCallBack: undefined,
        parentScreen: "bank-account-reconciliation",
        dataModel: {
          AccountNo: this.dataModel.AccountNo,
          BSBNO: this.dataModel.BsbNo,
          BankAccountCode: this.baseView.id,
          FXCurrency: this.dataModel.CurrencyCode,
          ExchangeRate: this.dataModel.ExchangeRate,
        },
        formOptions: {
          gcLabelLocation: "left",
        },
        titleLines: [
          `${this.dataModel.AccountName}`,
          `${this.dataModel.BsbNo} ${this.dataModel.AccountNo}`,
        ],
      };
    },

    // Filter Panel
    filterPanelTabOptions() {
      return {
        dataSource: [
          {
            id: 0,
            text: "Filters",
          },
        ],
        selectedIndex: 0,
      };
    },

    filterFormItems() {
      return [
        {
          screenField: "FXAmount",
          filterDataField: "FXTransactionAmountAbs",
          type: "Integer",
        },
        {
          screenField: "TransactionCode",
          filterDataField: "ComputedTransactionNo",
          filterLabel: "Transaction",
          filterEditorType: "dxTextBox",
          dataType: "string",
          type: "Text",
        },
        {
          screenField: "Date",
          filterDataField: "TransactionDate",
        },
        {
          screenField: "DateCreated",
          filterDataField: "DateCreated",
          label: "Date Created",
        },
        {
          screenField: "TradingPartner",
          filterDataField: "TransactionPartner",
          label: "Partner",
          type: "Text",
        },
        {
          screenField: "Customer",
          filterDataField: "CustomerCode",
        },
        {
          screenField: "Supplier",
          filterDataField: "SupplierCode",
        },
        {
          screenField: "TransactionType",
          touchEnabled: false,
          dataSourceConfig: {
            data: [
              "Supplier Payment",
              "Customer Receipt",
              "Sundry Payment",
              "Sundry Receipt",
            ],
          },
        },
        {
          screenField: "TransactionMethod",
          label: "Method",
          filterLabel: "Method",
          filterDataField: "TransactionMethod",
        },
      ];
    },
  },
};
</script>

<style lang="scss">
.bank-reconciliation {
  .gc-header-form .header-form {
    margin-bottom: unset !important;
  }

  .dx-treelist-headers .dx-treelist-table .dx-row > td {
    font-size: 12px !important;
  }
  .gc-details-grid {
    .dx-treelist-header-panel {
      height: 40px;
      .dx-toolbar-before,
      .dx-toolbar-after {
        height: 40px;
      }

      .dx-button[aria-label="Add New"],
      .dx-button[aria-label="Expand"],
      .dx-button[aria-label="Collapse"] {
        height: 22px;
        .dx-button-content {
          padding: unset !important;
          display: flex;
          -webkit-box-pack: center;
          -ms-flex-pack: center;
          justify-content: center;
          -ms-flex-line-pack: center;
          align-content: center;

          .dx-icon {
            font-size: 12px;
            margin-right: 0;
            padding: 0;
            margin-top: 2px;
          }

          .dx-button-text {
            display: inline-flex;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            padding: 5px 5px 5px 0px;
            font-size: 10px;
          }
        }
      }
    }
    .dx-button[aria-label="Expand"],
    .dx-button[aria-label="Collapse"] {
      background-color: #03a9f4;
      color: #fff !important;
      .dx-button-content .dx-icon::before {
        color: #fff !important;
      }
    }
  }
}
</style>
